
import { createInstance, OptimizelyProvider } from "@optimizely/react-sdk";
import { memo, useState } from "react";
import { useUserQuery } from "../monitor/User.state";
import { useRollbar } from "@rollbar/react";

const optimizelyClient = createInstance({
  sdkKey: process.env.REACT_APP_OPTIMIZELY_KEY,
})

const AppUserContainer = ({ children }) => {
  const [, setIsClientReady] = useState(null)
  const user = useUserQuery()
  const rollbar = useRollbar()
  const hasUserId = user && user?.id
  let userConfig = {}
  if (hasUserId) {
      userConfig = {
          id: String(user?.id),
          attributes: {
              user_id: user?.id,
              email: user?.email,
              super: user?.super_admin,
          }
      }
  }

  function isClientValid() {
      return optimizelyClient.getOptimizelyConfig() !== null
  }

  optimizelyClient.onReady().then(() => {
      isClientValid() && setIsClientReady(true)
  })

  rollbar.configure({
      payload: {
          person: {
              id: String(user?.id),
              username: user?.email,
              email: user?.email,
              super: user?.super_admin,
          }
      }
  })

  return (
      <OptimizelyProvider
          optimizely={optimizelyClient}
          user={userConfig}
          key={user?.id}
      >
          {children}
      </OptimizelyProvider>
  )
}

export default memo(AppUserContainer)